import classNames from "classnames";

import { DComponent } from "../../../../../../components/DComponent";
import InputField from "../../../../../../components/InputField";
import PhoneNumber from "../../../../../../components/PhoneNumber";
import SelectBox from "../../../../../../components/SelectBox";
import { Address } from "../../../../../../models/Address";
import { Country } from "../../../../../../models/Country";
import { District } from "../../../../../../models/District";
import { Ward } from "../../../../../../models/Ward";
import { DEFAULT_COUNTRY } from "../../../../../../utils/constant";
import { getCountryFromPhone } from "../../../../../../utils/phone";
import { defer } from "../../../../../../utils/script";
import { isCountryVN } from "../../../../../../utils/utils";

export default class AddressForm extends DComponent {
  constructor({
    parent,
    id,
    type,
    className = "",
    countryList = [],
    phoneOptions = {},
    tabIndex = 0,
    onDialCode = () => { },
    onChangePhone = () => { },
    inputPadding,
    scrollParent,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("AddressForm", className),
    }, true);
    this.type = type;
    this.phoneOptions = phoneOptions;
    this.tabIndex = tabIndex;
    this.inputPadding = inputPadding;
    this.scrollParent = scrollParent;
    /** @type {InputField} */
    this.name = undefined;
    /** @type {PhoneNumber} */
    this.phone = undefined;
    /** @type {PhoneNumber} */
    this.phoneTemp = undefined;
    /** @type {InputField} */
    this.email = undefined;
    /** @type {InputField} */
    this.address = undefined;
    /** @type {SelectBox} */
    this.city = undefined;
    /** @type {SelectBox} */
    this.district = undefined;
    /** @type {SelectBox} */
    this.ward = undefined;
    /** @type {CheckBox} */
    /** @type {InputField} */
    this.address2 = undefined;
    /** @type {InputField} */
    this.city2 = undefined;
    /** @type {InputField} */
    this.state = undefined;
    /** @type {InputField} */
    this.postalCode = undefined;
    this.currentCity = {};
    this.currentDistrict = {};
    this.currentWard = {};
    this.countryList = countryList;
    this.onDialCode = onDialCode;
    this.onChangePhone = onChangePhone;
    this.isEdited = true;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "AddressForm");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    let listInput = [
      {
        field: "input", name: "name", parent: $(".first-name", this.element), invalid: "checkout_fullNameEnter", placeholder: "checkout_fullNamePlaceholder",
        label: "checkout_fullName", maxlength: 250, isRequired: true,
        onChange: (value) => this.onChange(value),
        autoScroll: true,
        scrollPadding: this.inputPadding,
        scrollParent: this.scrollParent,
      },
      {
        field: "phone", id: "phone_" + this.type, name: "phone", parent: $(".phone", this.element), invalid: "checkout_enterPhoneValid", placeholder: "checkout_enterPhone",
        label: "checkout_phoneNumber", maxlength: 250, isRequired: true, type: InputField.TYPE.TEL, options: this.phoneOptions,
        onDialCode: (value) => { this.setIsEdit(); typeof this.onDialCode === "function" && this.onDialCode(value); },
        onChange: (value) => { this.onChange(value); typeof this.onChangePhone === "function" && this.onChangePhone(value); },
        autoScroll: true,
        scrollPadding: this.inputPadding,
        scrollParent: this.scrollParent,
      },
      { field: "phone", id: "phoneTemp_" + this.type, name: "phoneTemp", parent: $(".phone-temp", this.element) },
      {
        field: "input", name: "email", parent: $(".email", this.element), invalid: "checkout_enterEmailValid", placeholder: "checkout_enterEmail",
        label: "checkout_emailAddress", maxlength: 250, isRequired: true, type: InputField.TYPE.EMAIL,
        onChange: (value) => this.onChange(value),
        autoScroll: true,
        scrollPadding: this.inputPadding,
        scrollParent: this.scrollParent,
      },
      {
        field: "input", name: "address", parent: $(".address", this.element), invalid: "checkout_enterAddress", placeholder: "checkout_enterAddress",
        label: this.type === Address.TYPE.SHIPPING_INFO ? "checkout_shippingAddress" : this.type === Address.TYPE.BILLING_INFO ? "checkout_billingAddress" : "checkout_address", maxlength: 250, isRequired: true,
        onChange: (value) => this.onChange(value),
        autoScroll: true,
        scrollPadding: this.inputPadding,
        scrollParent: this.scrollParent,
      },
      {
        field: "select", name: "city", parent: $(".city", this.element), invalid: "checkout_chooseCity", placeholder: "checkout_placeholderCity",
        label: "checkout_city", maxlength: 250, isRequired: true, options: { searchField: ['value', 'text', 'codename'] },
        onChange: (value) => this.onChangeAddress(value, AddressForm.ADDRESS_TYPE.CITY),
        autoScroll: true,
        scrollPadding: this.inputPadding ? this.inputPadding + 256 : undefined,
        scrollParent: this.scrollParent,
      },
      {
        field: "select", name: "district", parent: $(".district", this.element), invalid: "checkout_chooseDitrict", placeholder: "checkout_placeholderDistrict",
        label: "checkout_district", maxlength: 250, isRequired: true, options: { searchField: ['value', 'text', 'codename'] },
        onChange: (value) => this.onChangeAddress(value, AddressForm.ADDRESS_TYPE.DISTRICT),
        autoScroll: true,
        scrollPadding: this.inputPadding ? this.inputPadding + 256 : undefined,
        scrollParent: this.scrollParent,
      },
      {
        field: "select", name: "ward", parent: $(".ward", this.element), invalid: "checkout_chooseWard", placeholder: "checkout_placeholderWard",
        label: "checkout_ward", maxlength: 250, isRequired: true, options: { searchField: ['value', 'text', 'codename'] },
        onChange: (value) => this.onChangeAddress(value, AddressForm.ADDRESS_TYPE.WARD),
        autoScroll: true,
        scrollPadding: this.inputPadding ? this.inputPadding + 256 : undefined,
        scrollParent: this.scrollParent,
      },
      {
        field: "input", name: "address2", parent: $(".address-2", this.element), placeholder: "checkout_addressLine2Placeholder",
        label: "checkout_addressLine2", maxlength: 250, isRequired: false,
        onChange: (value) => this.onChange(value),
        autoScroll: true,
        scrollPadding: this.inputPadding,
        scrollParent: this.scrollParent,
      },
      {
        field: "input", name: "city2", parent: $(".city-2", this.element), invalid: "checkout_city2Placeholder", placeholder: "checkout_city2Placeholder",
        label: "checkout_city2", maxlength: 250, isRequired: true,
        onChange: (value) => this.onChange(value),
        autoScroll: true,
        scrollPadding: this.inputPadding,
        scrollParent: this.scrollParent,
      },
      {
        field: "input", name: "state", parent: $(".state", this.element), invalid: "checkout_stateProvincePlaceholder", placeholder: "checkout_stateProvincePlaceholder",
        label: "checkout_stateProvince", maxlength: 250, isRequired: true,
        onChange: (value) => this.onChange(value),
        autoScroll: true,
        scrollPadding: this.inputPadding,
        scrollParent: this.scrollParent,
      },
      {
        field: "input", name: "postalCode", parent: $(".postal-code", this.element), invalid: "checkout_postalCodePlaceholder", placeholder: "checkout_postalCodePlaceholder",
        label: "checkout_postalCode", maxlength: 50, isRequired: true,
        onChange: (value) => this.onChange(value),
        autoScroll: true,
        scrollPadding: this.inputPadding,
        scrollParent: this.scrollParent,
      },
    ]
    listInput.forEach((options, index) => {
      if (options.field === "input") {
        this[options.name] = new InputField({
          tabIndex: this.tabIndex + index + 1,
          ...options
        })
      }
      if (options.field === "phone") {
        this[options.name] = new PhoneNumber({
          tabIndex: this.tabIndex + index + 1,
          ...options
        })
        window[options.name] = this[options.name]
      }
      if (options.field === "select") {
        this[options.name] = new SelectBox({
          tabIndex: this.tabIndex + index + 1,
          ...options
        });
        if (options.name === "city") {
          defer(() => this.city, () => {
            this.city.addOption(this.countryList, "name", "codename")
          })
        }
      }
    });
  }

  setActiveField(isRFQOrder = false) {
    if (isRFQOrder) {
      $(this.element).addClass("rfq");
      $(".phone", this.element).addClass("hide");
      $(".address", this.element).addClass("hide");
      this.showAddressVietNam(false);
      this.showAddressOtherVietNam(false);
    } else {
      $(this.element).removeClass("rfq");
      $(".phone", this.element).removeClass("hide");
      $(".address", this.element).removeClass("hide");
      this.setAddressCountry(this.phone.getCountry());
    }
  }

  setAddressCountry(addressCountry = DEFAULT_COUNTRY) {
    let isVN = isCountryVN(addressCountry);
    this.showAddressVietNam(isVN);
    this.showAddressOtherVietNam(!isVN);
  }

  showAddressVietNam(isShow = false) {
    if (isShow) {
      let labelAddress = this.type === Address.TYPE.SHIPPING_INFO ? "checkout_shippingAddress" : this.type === Address.TYPE.BILLING_INFO ? "checkout_billingAddress" : "checkout_address";
      this.address.setLabel(labelAddress, "checkout_enterAddress", "checkout_enterAddress")
      $(".city", this.element).removeClass("hide");
      $(".district", this.element).removeClass("hide");
      $(".ward", this.element).removeClass("hide");
    } else {
      $(".city", this.element).addClass("hide");
      $(".district", this.element).addClass("hide");
      $(".ward", this.element).addClass("hide");
    }
  }

  showAddressOtherVietNam(isShow = false) {
    if (isShow) {
      this.address.setLabel("checkout_addressLine1", "checkout_addressLine1Placeholder", "checkout_addressLine1Enter")
      $(".address-2", this.element).removeClass("hide");
      $(".city-2", this.element).removeClass("hide");
      $(".state", this.element).removeClass("hide");
      $(".postal-code", this.element).removeClass("hide");
    } else {
      $(".address-2", this.element).addClass("hide");
      $(".city-2", this.element).addClass("hide");
      $(".state", this.element).addClass("hide");
      $(".postal-code", this.element).addClass("hide");
    }
  }

  /** @param {Address} address */
  fillData(address = {}) {
    $(".id-address", this.element).text(address.id || "");
    $(".type-address", this.element).text(address.addressType || "");
    this.name.setValue(address.firstName || "");
    this.phone.setNumber(address.phoneNumber || "");
    this.email.setValue(address.email || "");
    this.address.setValue(address.address || "");
    if (address.city) {
      let city = Country.getCountry(this.countryList, address.city);
      if (city?.codename) {
        this.currentCity = city;
        this.city.setValue(city.codename);

        this.district.addOption(city.districts, "name", "codename");
        let district = District.getDistrict(city.districts, address.state);
        if (district?.codename) {
          this.currentDistrict = district;
          this.district.setValue(district && district.codename);

          this.ward.addOption(district.wards, "name", "codename");
          let ward = Ward.getWard(district.wards, address.ward);
          this.currentWard = ward;
          this.ward.setValue(ward && ward.codename);
        }
      }
    } else {
      this.city.setValue("");
      this.district.setValue("");
      this.ward.setValue("");
    }
    this.city2.setValue(address.city || "");
    this.address2.setValue(address.addressOption || "");
    this.state.setValue(address.state || "");
    this.postalCode.setValue(address.zipCode || "");

    this.setAddressCountry(this.phone.getCountry());
    this.element.attr("type", address.addressType || "");
  }

  getLoadingInput() {
    return this.name.getLoading() || this.phone.getLoading() || this.phoneTemp.getLoading() || this.address.getLoading() || this.city.getLoading() || this.district.getLoading() || this.ward.getLoading();
  }


  /** @returns {Address}*/
  getDataAddress(isRFQOrder = false, hasId = false) {
    let result = new Address();
    result.firstName = this.name.getValue();
    result.email = (this.email.getValue() || "").trim().toLowerCase();
    if (!isRFQOrder) {
      result.phoneNumber = this.phone.getNumber();
      result.address = this.address.getValue();
      if (isCountryVN(this.phone.getCountry())) {
        result.city = this.city.getLabel();
        result.state = this.district.getLabel();
        result.ward = this.ward.getLabel();
      } else {
        result.addressOption = this.address2.getValue();
        result.city = this.city2.getValue();
        result.state = this.state.getValue();
        result.zipCode = this.postalCode.getValue();
      }
      if (hasId) {
        result.id = this.getId();
      }
      result.addressType = this.getType();
      result.country = getCountryFromPhone(this.phone.getNumber());
    }
    return result;
  }

  getParamsAddress(isRFQOrder = false, hasId = false) {
    return Address.genParamsBilling(this.getDataAddress(isRFQOrder, hasId));
  }

  setId(id) {
    this.id = id;
    return $(".id-address", this.element).text(id);
  }

  getId() {
    return $(".id-address", this.element).text();
  }

  setType(type) {
    return $(".type-address", this.element).text(type);
  }

  getType() {
    return $(".type-address", this.element).text();
  }

  onChange(value) {
    this.setIsEdit();
  }

  onChangeAddress(value, type) {
    switch (type) {
      case AddressForm.ADDRESS_TYPE.CITY:
        let currentCity = Country.getCountry(this.countryList, value, "codename");
        this.currentCity = currentCity;
        if (currentCity?.districts) {
          this.district.addOption(currentCity.districts, "name", "codename", false);
        }
        this.setIsEdit();
        break;
      case AddressForm.ADDRESS_TYPE.DISTRICT:
        if (this.currentCity?.districts) {
          let district = District.getDistrict(this.currentCity.districts, value, "codename");
          if (district?.wards) {
            this.ward.addOption(district.wards, "name", "codename", false);
          }
        }
        this.setIsEdit();
        break;
      case AddressForm.ADDRESS_TYPE.WARD:
        this.ward.blur();
        this.setIsEdit();
        break;
      default:
        break;
    }
  }

  isSameCountry(phoneNumber, currentShipping) {
    this.phoneTemp.setNumber(phoneNumber || "");
    let shippingTemp = this.phoneTemp.getCountry();
    let shippingLocal = (currentShipping || "").toUpperCase();

    if (shippingTemp && shippingLocal && shippingTemp === shippingLocal) {
      return true;
    }
    return false;
  }

  getDialCode(phoneNumber) {
    this.phoneTemp.setNumber(phoneNumber || "");
    return this.phoneTemp.getCountry();
  }


  validateForm = (isShowValid = true, isRFQ = false) => {
    let valTotal = true;

    valTotal &= this.name.isValidate(isShowValid);
    if (!isRFQ) {
      valTotal &= this.phone.isValidate(isShowValid, valTotal);
    }
    valTotal &= this.email.isValidate(isShowValid, valTotal);
    if (!isRFQ) {
      valTotal &= this.address.isValidate(isShowValid, valTotal);
      if (isCountryVN(this.phone.getCountry())) {
        valTotal &= this.city.isValidate(isShowValid, valTotal);
        valTotal &= this.district.isValidate(isShowValid, valTotal);
        valTotal &= this.ward.isValidate(isShowValid, valTotal);
      } else {
        valTotal &= this.city2.isValidate(isShowValid, valTotal);
        valTotal &= this.state.isValidate(isShowValid, valTotal);
        valTotal &= this.postalCode.isValidate(isShowValid, valTotal);
      }
    }
    return valTotal;
  }

  resetAddress(isOnlyAddress = false) {
    this.setId("");
    this.setType("");
    if (!isOnlyAddress) {
      this.name.clearInput();
      this.phone.clearInput();
      this.phoneTemp.clearInput();
      this.email.clearInput();
    }
    this.address.clearInput();

    let countryCode = this.phone.getCountry();
    let isVN = isCountryVN(countryCode);
    if (isVN) {
      this.city.clearInput();
      this.district.clearInput();
      this.ward.clearInput();
    } else {
      this.address2.clearInput();
      this.city2.clearInput();
      this.state.clearInput();
      this.postalCode.clearInput();
    }
    this.setAddressCountry(countryCode);
  }

  setIsEdit(isEdited = true) {
    if (this.isEdited !== isEdited) this.isEdited = isEdited;
  }
  getIsEdited() {
    return this.isEdited;
  }

  static ADDRESS_TYPE = {
    CITY: "city",
    DISTRICT: "district",
    WARD: "ward"
  }
}